(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

window.addEventListener("load", function () {

    // check if tfaf page
    var wrapper = document.querySelector("div.tfaf_admin_wrapper");

    if (!wrapper) {
        return;
    }

    //store tabs
    var tabs = document.querySelectorAll("ul.nav-tabs > li");
    var i = 0;
    for (i = 0; i < tabs.length; i++) {
        tabs[i].addEventListener("click", switchTab);
    }

    function switchTab(event) {
        event.preventDefault();

        document.querySelector("ul.nav-tabs li.active").classList.remove("active");
        document.querySelector(".tab-pane.active").classList.remove("active");

        var clickedTab = event.currentTarget;
        var anchor = event.target;
        var activePaneID = anchor.getAttribute("href");

        clickedTab.classList.add("active");
        document.querySelector(activePaneID).classList.add("active");
    }

    var up_buttons = document.querySelectorAll("button.up_button");
    for (i = 0; i < up_buttons.length; i++) {
        up_buttons[i].addEventListener("click", moveRowUp);
    }

    function moveRowUp() {
        var row = this.parentNode.parentNode,
            table = row.parentNode,
            sibling = row.previousElementSibling,
            nextTagName = sibling.childNodes[0].tagName;

        if (!(nextTagName === "TH")) {
            this.parentNode.parentElement.classList.add("hide");

            row.addEventListener('transitionend', function eventWrapper() {
                table.insertBefore(row, sibling);
                updatePositions(table);
                row.removeEventListener('transitionend', eventWrapper, false);
                setTimeout(function () {
                    row.firstChild.parentElement.classList.remove("hide");
                }, 200);
            }, false);
        }
    }

    var down_buttons = document.querySelectorAll("button.down_button");
    for (i = 0; i < down_buttons.length; i++) {
        down_buttons[i].addEventListener("click", moveRowDown);
    }

    function moveRowDown() {
        var row = this.parentNode.parentNode,
            sibling = row.nextElementSibling,
            table = row.parentNode;

        if (sibling != null) {
            this.parentNode.parentElement.classList.add("hide");

            row.addEventListener('transitionend', function eventWrapper() {
                table.insertBefore(sibling, row);
                updatePositions(table);
                row.removeEventListener('transitionend', eventWrapper, false);
                setTimeout(function () {
                    row.firstChild.parentElement.classList.remove("hide");
                }, 100);
            }, false);
        }
    }

    function updatePositions(table) {
        var rows = [].slice.call(table.childNodes, 1);
        var positions = '';
        rows.forEach(function (rows) {
            return positions += rows.childNodes[0].textContent + "-";
        });
        document.getElementById("tfaf_menu_positions").value = positions;

        // Change table heading
        table.childNodes[0].childNodes[0].textContent = "Old Position";

        // Activate save order button
        document.getElementById('tfaf-button-save-order').style.display = "inline";
    }
});

jQuery(document).ready(function ($) {

    $(document).on('click', '.js-image-upload', function (e) {
        e.preventDefault();
        var $button = $(this);

        var file_frame = wp.media.frames.file_frame = wp.media({
            title: 'Select or upload an Image',
            library: {
                type: 'image'
            },
            button: {
                text: 'Select Image'
            },
            multiple: false
        });

        file_frame.on('select', function () {
            var attachment = file_frame.state().get('selection').first().toJSON();
            $button.siblings('.image-upload').val(attachment.url);
        });

        file_frame.open();
    });
});

},{}]},{},[1]);
